import type { MongoAbility } from '@casl/ability';
import { AbilityBuilder, createMongoAbility } from '@casl/ability';

import type { RootState } from '~/store';

import { SCOPE_TO_RULES } from './scope-to-rules';

export type Actions = 'read' | 'create' | 'update' | 'delete' | 'manage' | 'updateWithoutStatus';
export type Subjects =
  | 'Teams'
  | 'Tournaments'
  | 'Tournament'
  | 'Games'
  | 'TourTypes'
  | 'Positions'
  | 'Players'
  | 'Referees'
  | 'Admins'
  | 'Groups'
  | 'all';

export interface AbilityContextData {
  role: RootState['admin']['role'];
  scopes: NonNullable<RootState['admin']['scope']>;
}

export type AppAbility = MongoAbility<[Actions, Subjects]>;

export function defineAbility({ role, scopes }: AbilityContextData) {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  if (role === 'ADMIN' || role === 'DEVELOPER') {
    can('manage', 'all');
  } else {
    scopes.forEach(scope => {
      SCOPE_TO_RULES[scope](can);
    });
  }

  return build();
}
